







import TableFolder from "@/components/document/folder/TableFolder.vue";
import TemplateAdministrator from "@/templates/TemplateAdministrator.vue";
import Vue from "vue";
export default Vue.extend({
  components: { TemplateAdministrator, TableFolder },
});
